import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, Answer } from '@df/interfaces';
import { TaskService } from '@app/core/services/task.service';

@Component({
    selector: 'app-question-task',
    templateUrl: './question-task.component.html',
    styleUrls: ['../../../../../../_pipes/exercise-format.pipe.scss', './question-task.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTaskComponent implements OnInit {
    @Input() question: Question;
    @Input() exercise;
    @Input() qIndex: number;
    @Input() cardId: number;
    @Input() studentId: number;
    @Input() isAuthorCard: boolean;
    @Input() isAccessCard: boolean;
    @Input() prev_results: Array<any> = [];
    @Output() questionAnswered = new EventEmitter();
    answerStr: string;

    constructor(private taskService: TaskService) {}

    public ngOnInit(): void {
        // console.log(this.exercise);
        if (this.prev_results) {
            this.prev_results.forEach(item => {
                if (this.exercise.id === item.exercise_id) {
                    this.answerStr = item.short_answer;
                    this.answerInputChange(item.short_answer);
                }
            });
            return;
        }
        this.answerStr = this.question.answers[0].shortAnswer;
    }

    clearAnswer(event) {
        this.answerStr = '';
        this.isEmptyAnswer(event);
    }

    answerInputChange(event) {
        const questionCorrect: boolean = this.taskService.checkCorrectAnswer(this.answerStr, this.question);
        let fullAnsw: string = null;
        if (questionCorrect) {
            for (const answ of this.question.answers) {
                const shortAnswerStr = answ.shortAnswer.split(' ')[0];
                if (this.answerStr === shortAnswerStr) {
                    this.answerStr = answ.shortAnswer;
                }
                if (this.answerStr === answ.fullAnswer) {
                    fullAnsw = this.answerStr;
                }
            }
        }

        const answerObject: Answer = {
            student: this.studentId,
            fullAnswer: fullAnsw,
            card: this.cardId,
            shortAnswer: this.answerStr,
            exercise: this.exercise.id,
            correct: true,
            question: this.question.id
        };

        for (const exerAnswer of this.exercise.answers) {
            if (questionCorrect) {
                if (this.answerStr === exerAnswer.shortAnswer) {
                    answerObject.shortAnswer = this.answerStr;
                } else {
                    answerObject.fullAnswer = this.answerStr;
                }
                break;
            } else {
                answerObject.shortAnswer = this.answerStr;
                answerObject.correct = false;
            }
        }
        if (event) {
            this.questionAnswered.emit(answerObject);
        }
    }

    checkQuestionAnswer(): boolean {
        return this.taskService.checkCorrectAnswer(this.answerStr, this.question);
    }

    isEmptyAnswer(event = false) {
        if (this.answerStr === '') {
            if (event) {
                this.answerInputChange(event);
            }
            return true;
        }
        return false;
    }
}
